import styled from 'styled-components'

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  font-family: Barlow;

  @media (min-width: 992px) {
    width: 632px;
  }
`

export const ErrorImage = styled.img`
  height: 280px;
  object-fit: cover;

  @media (min-width: 992px) {
    height: 400px;
  }
`

export const DesText = styled.div`
  color: #303032;
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;

  @media (min-width: 992px) {
    font-size: 32px;
    line-height: 48px;
  }
`

export const ComplementText = styled.div`
  color: #303032;
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;

  @media (min-width: 992px) {
    font-size: 18px;
    line-height: 24px;
  }
`
